<template>
  <div>
    <b-modal id="modal-encrypt" class="modal-class-encrypt" no-close-on-backdrop centered hide-header hide-footer>
        <!-- <p class="default-text-style-encrypt">Create a password to encrypt “{{item.file_name}}“</p> -->
        <!-- <p class="default-text-style-encrypt-body">Please remember the password and keep it secure.</p> -->
        <!-- <p class="mb-4 default-text-style-encrypt-body">The password can't be recovered if you lose or forget it.</p> -->
        <p class="default-text-style-encrypt">Create a password to encrypt this file</p>
        <p class="default-text-style-encrypt-body">Please remember the password carefully.</p>
        <p class="mb-4 default-text-style-encrypt-body">The password can't be recovered if you lose it.</p>
        <!-- <p>{{item}}</p> -->
        <form action="">
            <div class="form-control-encrypt">
                <input
                    id="password-encrypt"
                    placeholder="Create file password"
                    :type="passwordState"
                    class="form-input-encrypt"
                    v-model.trim="$v.password.$model"
                    :class="{'is-invalid':$v.password.$error, 'is-valid':!$v.password.$invalid}">
                <img v-if="passwordState == 'password'" src="@/assets/images/icon/fi-rr-eye-close.svg" alt="" @click="showPassword()">
                <img v-else src="@/assets/images/icon/fi-rr-eye-open.svg" alt="" @click="showPassword()">
                <div class="invalid-feedback ml-3">
                    <span v-if="!$v.password.required">File password is required.</span>
                    <!-- <span v-if="!$v.password.minLength">Minimum file password is {{$v.password.$params.minLength.min}} characters.</span> -->
                    <span v-if="!$v.password.maxLength">The file password can’t be longer than {{$v.password.$params.maxLength.max}} characters.</span>
                </div>
            </div>
            <div class="form-control-encrypt">
                <input
                    id="confirm-password-encrypt"
                    placeholder="Confirm file password"
                    :type="confirmPasswordState"
                    class="form-input-encrypt "
                    v-model.trim="$v.confirmPassword.$model"
                    :class="{'is-invalid':$v.confirmPassword.$error, 'is-valid': (password != '') ? !$v.confirmPassword.$invalid : ''}">
                <img v-if="confirmPasswordState == 'password'" src="@/assets/images/icon/fi-rr-eye-close.svg" alt="" @click="showPasswordConfirm()">
                <img v-else src="@/assets/images/icon/fi-rr-eye-open.svg" alt="" @click="showPasswordConfirm()">
                <div class="invalid-feedback ml-3">
                    <span v-if="!$v.confirmPassword.sameAsPassword">Confirm file password must be same as file password.</span>
                </div>
            </div>
        </form>
        <div class="btn-modal-encrypt">
            <button class="mr-3 btn-close" @click="close()">Cancel</button>
            <button class="mr-2 btn-encrypt" @click="encryptBtn()" :disabled="$v.$invalid">Encrypt</button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { required, 
    // minLength,
    maxLength, sameAs } from 'vuelidate/lib/validators'

export default {
    name: 'Encrypt',
    props: ['item'],
    data() {
        return {
            password: '',
            confirmPassword: '',
            passwordState: 'password',
            confirmPasswordState: 'password',
            maxPassLength: 18
        }
    },
    validations: {
        password: {
            required,
            // minLength: minLength(8),
            maxLength: maxLength(16)
        },
        confirmPassword: {
            sameAsPassword: sameAs('password')
        }
    },
    computed: {
        listing: {
            // getter
            get: function () {
                return this.$store.getters[this.$store.getters['state/state']+'/items'];
            },
            // setter
            set: function (newValue) {
                this.$store.commit(this.$store.getters['state/state']+"/SET_ITEMS",newValue);
            }
        },
        detail() {
            return this.$store.getters[this.$store.getters['state/state']+'/item']
        },
        user_id(){
            return this.$store.getters['user/id']
        },
        state(){
            return this.$store.getters['state/state'];
        },
        showBreadCumb() {
          return this.$store.getters['storage/showBreadcumb']
        },
        // listEnterprise(){
        //     return this.$store.getters["user/listEnterpriseUser"]
        // },
    },
    // watch: {
    //     password() {
    //         this.password = this.password.substring(0, this.maxPassLength)
    //     }
    // },
    methods: {
        refresh(){
            this.$store.dispatch(this.state+"/listing",this.showBreadCumb ? "" : '1')
        },
        showPassword() {
            if(this.passwordState === 'password'){
                this.passwordState = 'text'
            } else {
                this.passwordState = 'password'
            }
        },
        showPasswordConfirm() {
            if(this.confirmPasswordState === 'password'){
                this.confirmPasswordState = 'text'
            } else {
                this.confirmPasswordState = 'password'
            }
        },
        close() {
            this.password = ''
            this.confirmPassword = ''
            this.$root.$emit('bv::hide::modal', 'modal-encrypt')
        },
        encryptBtn() {
            this.$ga.event('encrypt_file', 'actionx', 'labelx', 1)

            // if (document.getElementById("uploadLoading").style.display == 'block'){
                // document.getElementById("encryptLoading").style.display = "block";
                // document.getElementById("encryptLoading").style.right = "417px";
            // } else if(document.getElementById("uploadLoading").style.display == 'none'){
                // document.getElementById("encryptLoading").style.display = "block";
                // document.getElementById("encryptLoading").style.right = "0";

            // }
            var idx = this.listing.findIndex((v)=>{
                return v._id == this.item._id
            })
            var detailX = this.listing[idx]

            detailX.locked = true
            detailX.encrypt = 1
            
            if(detailX.locked == true){
                var payload = {
                    password: this.password,
                    confirm_password: this.confirmPassword,
                    id: this.item._id,
                    directory: this.item.directory
                }

                // this.item.encrypt =  { code: 1, status: "progress encrypt" }
                // this.$store.commit('encrypt/ADD_PROGRESS', this.item)
                this.$store.dispatch('encrypt/setEncrypt', payload)
                .then(()=>{
                    this.$toasted.show('Encryption will begin immediately.',{ 
                        theme: "toasted-primary", 
                        position: "bottom-center", 
                        duration : 2000
                    })
                    this.$root.$emit('bv::hide::modal', 'modal-encrypt')
                })
                // var firefoxAgent = this.$browserDetect.isFirefox
                // var safariAgent = this.$browserDetect.isSafari
                // var operaAgent = this.$browserDetect.isOpera
                if(this.state == 'workgroup'){
                // if((firefoxAgent || safariAgent || operaAgent) && this.state == 'workgroup'){
                    // var idOwner = this.$store.getters['workgroup/workgroup'].owner_id
                    var index = this.listing.findIndex((v)=>{
                        return v._id == this.item._id
                    })
                    var detail = this.listing[index]
                    // detail.encrypt = { code: 1, status: "progress encrypt" }
                    detail.locked = true
                    if(detail.locked == true){
                        var intervalWg = setInterval(()=>{
                            this.$store.dispatch('storage/fileretrieve',{_id:this.item._id, directory: this.item.directory})
                            .then((res)=>{
                                if(res.locked != true){
                                    this.$store.dispatch('notif/getAllNotification')
                                    clearInterval(intervalWg)
                                    var payload = {}
                                    payload.body = {
                                        datafile: {
                                            extension: res.extension,
                                            parent_id: res.parent_id,
                                            file_name: res.file_name,
                                            _id: res._id
                                        },
                                        group_by: null,
                                        icon: '',
                                        isread: false,
                                        time: Math.floor(Date.now()/1000),
                                        userid: this.user_id,
                                        id: res._id+'-'+moment().unix()
                                    }
                                    if(res.encrypt == 2){
                                        payload.body.message = `${res.file_name} is successfully encrypted`
                                        payload.body.title = 'Encrypted success'
                                        payload.body.datafile.encrypt = 2
                                        // payload.body.id = `${idOwner}-${payload.body.time}`
                                        // payload.body.datafile.encrypt = {code: 2, status: 'encrypted'}
                                    } else if(res.encrypt == 3){
                                        payload.body.message = `${res.file_name} failed to encrypt`
                                        payload.body.title = 'Encrypted failed'
                                        payload.body.datafile.encrypt = 3
                                        // payload.body.datafile.encrypt = {code: 3, status: 'encrypted failed'}
                                    }
                                    this.$store.dispatch('firebase/setNotifFirebase', payload.body)
                                    .then(()=>{
                                        this.refresh()
                                    })
                                }
                            })
                        },2000)
                    }
                } else {
                    // if(firefoxAgent || safariAgent || operaAgent){
                        var index2 = this.listing.findIndex((v)=>{
                            return v._id == this.item._id
                        })
                        var detail2 = this.listing[index2]
                        detail2.locked = true

                        if(detail2.locked == true){
                        // if(firefoxAgent || safariAgent || operaAgent && detail2.locked == true){
                            var interval = setInterval(()=>{
                                this.$store.dispatch('storage/fileretrieve',{_id:this.item._id, directory: this.item.directory})
                                .then((res)=>{
                                    if(res.locked != true){
                                        this.$store.dispatch('notif/getAllNotification')
                                        clearInterval(interval)
                                        var payload = {}
                                        payload.body = {
                                            datafile: {
                                                extension: res.extension,
                                                parent_id: res.parent_id,
                                                file_name: res.file_name,
                                                _id: res._id
                                            },
                                            group_by: null,
                                            icon: '',
                                            isread: false,
                                            time: Math.floor(Date.now()/1000),
                                            userid: this.user_id,
                                            id: res._id+'-'+moment().unix()
                                        }
                                        if(res.encrypt == 2){
                                            payload.body.message = `${res.file_name} is successfully encrypted`
                                            payload.body.title = 'Encrypted success'
                                            payload.body.datafile.encrypt = 2
                                            payload.body.workgroup = 'Personal'
                                            // payload.body.id = `${payload.body.userid}-${payload.body.time}`
                                            // payload.body.datafile.encrypt = {code: 2, status: 'encrypted'}
                                        } else if(res.encrypt == 3){
                                            payload.body.message = `${res.file_name} failed to encrypt`
                                            payload.body.title = 'Encrypted failed'
                                            payload.body.datafile.encrypt = 3
                                            payload.body.workgroup = 'Personal'
                                            // payload.body.datafile.encrypt = {code: 3, status: 'encrypted failed'}
                                        }
                                        this.$store.dispatch('firebase/setNotifFirebase', payload.body)
                                        .then(()=>{
                                            this.refresh()
                                        })
                                    }
                                })
                            },2000)
                        }
                    // }
                }
    
                this.password = null
                this.confirmPassword = null
            }
        }
    }
}
</script>

<style scoped>
::-ms-reveal
{
    display: none !important;
}
</style>